import * as React from 'react'
import { useMemo, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { DisplayDetails } from '../functions/functions'
import Pagination from '@mui/material/Pagination'

type Props = {
  additionalDetails: DisplayDetails
}

export function AdditionalDetails({ additionalDetails }: Props) {
  const [pageNumber, setPageNumber] = useState<number>(1)
  const itemsPerPage = 12

  const paginatedDetails = useMemo(
    () =>
      additionalDetails.slice(
        (pageNumber - 1) * itemsPerPage,
        pageNumber * itemsPerPage,
      ),
    [additionalDetails, pageNumber],
  )

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mt={3.2}
      >
        <Box>
          <Typography variant="h7">Additional Details</Typography>
        </Box>
      </Box>

      <Box
        mt={2.4}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: {
            xs: '16px',
            sm: '40px',
            md: '80px',
            lg: '115px',
          },
          rowGap: '30px',
          width: '100%',
        }}
      >
        {paginatedDetails.map(({ label, value }, index) => (
          <Box
            key={index}
            sx={{
              minWidth: '93px',
              minHeight: '42px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
          >
            <Typography variant="body2">{label}</Typography>
            <Typography variant="subtitle2">{value ?? '-'}</Typography>
          </Box>
        ))}
      </Box>

      <Box display="flex" justifyContent="flex-end" mt={1}>
        <Pagination
          count={Math.ceil(additionalDetails.length / itemsPerPage)}
          color="primary"
          size="small"
          onChange={(_, pageNumber) => {
            setPageNumber(pageNumber)
          }}
          style={{ display: 'flex' }}
          showFirstButton
          showLastButton
        />
      </Box>
    </>
  )
}
